export function Icon({ name, size = 20 }: { name: string; size?: number }) {
  const paths: Record<string, string> = {
    camera: "M14 5l-2-2H6L4 5H2v14h20V5h-8ZM12 9a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z",
    play: "m8 5 11 7-11 7V5Z",
    flip: "M4 9a8 8 0 0 1 14-3l2 3M20 3v6h-6M20 15a8 8 0 0 1-14 3l-2-3M4 21v-6h6",
    edit: "m15 4 5 5M4 20l5-1L21 7l-5-5L4 14v6Z",
    back: "m14 5-7 7 7 7",
    download: "M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5",
    check: "m5 12 4 4L19 6",
    close: "m6 6 12 12M6 18 18 6",
    library: "M4 4h16v16H4V4Zm4 4h8M8 12h8M8 16h5",
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.7"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path d={paths[name] || paths.camera} />
    </svg>
  );
}
